import ChartBaseController from "./chart_base_controller";

export default class ChartLinearGaugeController extends ChartBaseController {
  static values = {
    ...ChartBaseController.values,
    count: Number,
    max: Number,
    direction: String,
    average: Number,
  }

  connect() {
    super.connect();
    this.#renderChart();
  }

  #renderChart() {
    const options = this.getChartOptions();

    if (this.hasAverageValue && this.averageValue > 0) {
      options.targets = [
        {
          value: this.averageValue,
          placement: 'before',
          text: 'Form Average',
        },
      ];

      if (this.#calcPercentage() < this.averageValue) {
        options.bar = { fill: '#f44336' }
      } else {
        options.bar = { fill: '#00c853' }
      }
    } else {
      options.bar = { fill: '#007bff' }
    }

    agCharts.AgCharts.createGauge(options);
  }

  getChartOptions() {
    return {
      animation: { duration: 1 },
      container: this.chartTarget,
      type: 'linear-gauge',
      footnote: { text: 'Percentage (%)' },
      direction: this.directionValue,
      value: this.#calcPercentage(),
      thickness: 50,
      label: {
        enabled: true,
        placement: 'inside-start',
        avoidCollisions: true,
      },
      scale: {
        min: 0,
        max: 100,
        label: {
          enabled: false,
        }
      },
      cornerRadius: 99,
      cornerMode: 'container',
    }
  }

  #calcPercentage() {
    if (this.maxValue === 0) return 0;
    if (this.countValue >= this.maxValue) return 100;

    return Math.ceil((this.countValue / this.maxValue) * 100);
  }
}
